import React, { useState, useEffect } from "react";
import '../styles/tiles.css';
import '../styles/other.css';
import { PieChart } from 'react-minimal-pie-chart';
import { Link, Navigate } from "react-router-dom";
import Axios from 'axios';

// import utilities
import { checkForErrorsInRequest } from '../utilities/RequestsUtilities.js';
import { numberWithSpaces } from '../utilities/OtherUtilities.js';

// import assets
import icon_expand from '../assets/icon_expand.png';

class FinReports extends React.Component {
    setActualSection = this.props.setActualSection;

    constructor(props) {
        super(props);

        this.state = {
            selectedNatOrg: 0,
            selectedPeriod: 0,
            selectedStatTp: 0,
            selectedCurrency: 1,

            listOfNatOrg: ([{id:1, label: "Organization 1"},{id:2, label: "Organization 2"},{id:3, label: "Organization 3"}]),
            listOfPeriods: ([{id:1, label: "Period 1"},{id:2, label: "Period 2"},{id:3, label: "Period 3"}]),
            listOfStatTypes: ([{id:1, label: "StatType 1"},{id:2, label: "StatType 2"}]),
            listOfCurrencies: ([{id:1, label: "Currency 1"},{id:2, label: "Currency 2"},{id:3, label: "Currency 3"}]),

            categoryTypes: ([]),
            categoryTypesValues: ([]),
            categoryTypesValuesPrevSubm: ([]),
            globalIsOpen: true,
            currencyLabel: "...",
        }

    }

    componentDidMount(){
        this.setActualSection("fin_reports");
        this.loadData();
    }

    loadData = async () => {

        var filterValuesCurrent = "?nt_org_id="+this.state.selectedNatOrg+"&period_id="+this.state.selectedPeriod+"&ccy_id="+this.state.selectedCurrency+"&stmt_tp_id="+this.state.selectedStatTp;

        var prevId = this.getPrevId(this.state.selectedPeriod);
        var filterValuesPast = "?nt_org_id="+this.state.selectedNatOrg+"&period_id="+prevId+"&ccy_id="+this.state.selectedCurrency+"&stmt_tp_id="+this.state.selectedStatTp;
        //alert(this.state.selectedPeriod +" - "+prevId)

        // get CURRENT YEAR data
        Axios.get('/api/rpt/subm/get'+filterValuesCurrent).then(response => {
            this.setState({ categoryTypesValues: [] });
            if(checkForErrorsInRequest(response.data.msg, this.props.openAlertMessageTwoActions) == 1){ return; }
            this.setState({ categoryTypesValues: response.data.result });
        }).then(response => {

            // get PREV YEAR data
            Axios.get('/api/rpt/subm/get'+filterValuesPast).then(response => {
                this.setState({ categoryTypesValuesPrevSubm: [] });
                if(checkForErrorsInRequest(response.data.msg, this.props.openAlertMessageTwoActions) == 1){ return; }

                if(prevId){ // if prevId=null (it means that prevYear is not saved) then the API would automatically load "current" period and we don't want that so we will not show the received data
                    this.setState({ categoryTypesValuesPrevSubm: response.data.result });
                }
            }).then(response => {
                this.loadCategoryTypes();
            });

        });

        this.loadNatOrg();
        this.loadStatTp();
        this.loadPeriods();
        this.loadCurrency();
    }

    getPrevId = (currentId) => {
        if(currentId == 0)return -1;
        for(let oneRow of this.state.listOfPeriods){
            if(oneRow.id == currentId)return oneRow.prev_id;
        }
        return -1;
    }

    loadCategoryTypes = async () => {
        Axios.get('/api/ctg/get').then(response => {
            if(checkForErrorsInRequest(response.data.msg, this.props.openAlertMessageTwoActions) == 1){ return; }
            this.setState({ categoryTypes: [] });
            var categoryTypesList = response.data.result;

            // filter just categories for specific statement type
            if(this.state.selectedStatTp != 0){
                categoryTypesList = categoryTypesList.filter(item => item.stmt_tp_id == this.state.selectedStatTp);
            }

            categoryTypesList = categoryTypesList.map(item => {
                return {
                    ...item,
                    amount_prev_year: this.getPrevAmtByCtgId(item.id),
                    amt: this.getAmtByCtgId(item.id),
                    is_open: true,
                }
            });

            this.setState({ categoryTypes: categoryTypesList });
        });
    }

    getPrevAmtByCtgId(ctg_id) {
        for(let oneRow of this.state.categoryTypesValuesPrevSubm){
           if(oneRow.ctg_id == ctg_id && Number.isInteger(Number(oneRow.amt)))return parseInt(oneRow.amt);
        }
        return 0;
    }

    getAmtByCtgId(ctg_id) {
        for(let oneRow of this.state.categoryTypesValues){
           if(oneRow.ctg_id == ctg_id && Number.isInteger(Number(oneRow.amt)))return parseInt(oneRow.amt);
        }
        return 0;
    }

    loadNatOrg = () => {
        Axios.get('/api/nt_org/get').then(response => {
            this.setState({ listOfNatOrg: [] });
            if(checkForErrorsInRequest(response.data.msg, this.props.openAlertMessageTwoActions) == 1){ return; }
            this.setState({ listOfNatOrg: response.data.result });
        });
    }

    loadStatTp = () => {
        Axios.get('/api/stmt_tp/get').then(response => {
            this.setState({ listOfStatTypes: [] });
            if(checkForErrorsInRequest(response.data.msg, this.props.openAlertMessageTwoActions) == 1){ return; }
            this.setState({ listOfStatTypes: response.data.result });
        });
    }

    loadPeriods = () => {
        Axios.get('/api/period/get').then(response => {
            this.setState({ listOfPeriods: [] });
            if(checkForErrorsInRequest(response.data.msg, this.props.openAlertMessageTwoActions) == 1){ return; }
            this.setState({ listOfPeriods: response.data.result });
        });
    }

    loadCurrency = () => {
        Axios.get('/api/ccy/get').then(response => {
            this.setState({ listOfCurrencies: [] });
            if(checkForErrorsInRequest(response.data.msg, this.props.openAlertMessageTwoActions) == 1){ return; }

            var listOfCurrencies = ([]);
            response.data.result.forEach((item, index) => {
                listOfCurrencies.push({id: item.id, label: ""+item.iso_code});
            });
            this.setState({ listOfCurrencies: listOfCurrencies });

            // save name of currency of received submissions
            if(this.state.selectedCurrency != 0){
                for(let oneRow of response.data.result){
                    if(oneRow.id == this.state.selectedCurrency){
                        this.setState({ currencyLabel: oneRow.iso_code});
                        return;
                    }
                }
                this.setState({ currencyLabel: "Error"});
            }
        });
    }

    onNatOrgSelected = async (id) => {
        await this.setState({ selectedNatOrg: id });
        this.loadData();
    }

    onStatTpSelected = async (id) => {
        await this.setState({ selectedStatTp: id });
        this.loadData();
    }

    onPeriodSelected = async (id) => {
        await this.setState({ selectedPeriod: id });
        this.loadData();
    }

    onCurrencySelected = async (id) => {
        await this.setState({ selectedCurrency: id });
        this.loadData();
    }

    onIsOpenChanged = (newValue, idCategory) => {
        var newArray = this.state.categoryTypes;
        for(let oneRow of newArray){ if(oneRow.id == idCategory){ oneRow.is_open = newValue; } }
        this.setState({ categoryTypes: newArray})
    }

    onGlobalIsOpenChanged = () => {
        var newArray = this.state.categoryTypes;
        for(let oneRow of newArray){ oneRow.is_open = !this.state.globalIsOpen; }

        this.setState({ categoryTypes: newArray});
        this.setState({ globalIsOpen: !this.state.globalIsOpen});
    }

    hasChild = (idCategory) => {
        for(let oneRow of this.state.categoryTypes){
            if(oneRow.parent_id == idCategory) return true;
        }
        return false;
    }

    render() {
        return(
                <div className="verticalStack flex" style={{height: "calc(100vh - 80px)", overflowY: "scroll"}}>
                    <div className="horizontalStackCenter universalTableListingBar">
                        <span className="fontPoppinsRegular13Gray">{"Financial Reports"}</span>
                        <div className="flex"/>
                        <span className="fontPoppinsRegular13Gray onHoverToOrange clickable">{"Download PDF"}</span>
                    </div>

                    <div className="universalTile" style={{marginBottom: 20, marginLeft: 20, marginRight: 20}}>

                        <div className="horizontalStack" style={{position: "relative", backgroundColor: "var(--lightest-gray)"}}>

                            <div className="verticalStack flex" style={{paddingLeft: 20, paddingTop: 20, paddingRight: 20, paddingBottom: 20}}>
                                <span className="fontPoppinsRegular13" style={{marginBottom: 5}}>National Organization:</span>
                                <select className="universalTextInput topMenuSelectBox" name="nt_org" id="nt_org" style={{}} value={this.state.selectedNatOrg} onChange={e => this.onNatOrgSelected(e.target.value)}>
                                    <option value="">All organizations</option>
                                    {this.state.listOfNatOrg.map(function (item) {
                                        return (
                                           <option value={item.id}>{item.label}</option>
                                        )
                                    }.bind(this))}
                                </select>
                            </div>

                            <div className="verticalStack flex" style={{paddingTop: 20, paddingRight: 20, paddingBottom: 20}}>
                                <span className="fontPoppinsRegular13" style={{marginBottom: 5}}>Statement Type:</span>
                                <select className="universalTextInput topMenuSelectBox" name="stat_tp" id="stat_tp" style={{}} value={this.state.selectedStatTp} onChange={e => this.onStatTpSelected(e.target.value)}>
                                    <option value=""></option>
                                    {this.state.listOfStatTypes.map(function (item) {
                                        return (
                                           <option value={item.id}>{item.label}</option>
                                        )
                                    }.bind(this))}
                                </select>
                            </div>

                            <div className="verticalStack flex" style={{paddingTop: 20, paddingRight: 20, paddingBottom: 20}}>
                                <span className="fontPoppinsRegular13" style={{marginBottom: 5}}>Year:</span>
                                <select className="universalTextInput topMenuSelectBox" name="period" id="period" style={{}} value={this.state.selectedPeriod} onChange={e => this.onPeriodSelected(e.target.value)}>
                                    <option value=""></option>
                                    {this.state.listOfPeriods.map(function (item) {
                                        return (
                                           <option value={item.id}>{item.label}</option>
                                        )
                                    }.bind(this))}
                                </select>
                            </div>

                            <div className="verticalStack flex" style={{paddingTop: 20, paddingRight: 20, paddingBottom: 20}}>
                                <span className="fontPoppinsRegular13" style={{marginBottom: 5}}>Currency:</span>
                                <select className="universalTextInput topMenuSelectBox" name="currency" id="currency" style={{}} value={this.state.selectedCurrency} onChange={e => this.onCurrencySelected(e.target.value)}>
                                    {this.state.listOfCurrencies.map(function (item) {
                                        return (
                                           <option value={item.id}>{item.label}</option>
                                        )
                                    }.bind(this))}
                                </select>
                            </div>
                        </div>

                    </div>

                    {/* SECOND TILE WITH THE TABLE */}

                    <div className="universalLeftTileWithTable" style={{marginBottom: 20}}>

                        <div className="horizontalStackCenter">

                                <table className="universalTableInLeftTile" style={{marginTop: 10}}>
                                    <tr>
                                        <td className="universalTableInLeftTileHeader clickable" nowrap="nowrap" style={{minWidth: 200}} onClick={() => this.onGlobalIsOpenChanged()}>
                                            <div>
                                                <img className={this.state.globalIsOpen ? "expandButtonExpanded" : "expandButton"}  style={{width: "10px", height: "10px", marginRight: 10}} src={icon_expand}/>
                                                Category
                                            </div>
                                        </td>
                                        <td className="universalTableInLeftTileHeader" nowrap="nowrap">Previous Year</td>
                                        <td className="universalTableInLeftTileHeader" nowrap="nowrap">Current Year</td>
                                        <td className="universalTableInLeftTileHeader" nowrap="nowrap">Variance</td>
                                    </tr>


                                    {this.state.categoryTypes.map(function (item) {
                                        if(item.lvl == 1) return (
                                            <tbody>
                                            <tr className="clickable" key={item.id} style={{backgroundColor: "var(--gray-blue)"}} className="clickable" onClick={() => this.onIsOpenChanged(!item.is_open,item.id)}>
                                                <td nowrap="nowrap" style={{padding: 10}}>
                                                    <div className="fontPoppinsRegular15">
                                                        <img className={item.is_open ? "expandButtonExpanded" : "expandButton"}  style={{width: "10px", height: "10px",marginLeft: 5, marginRight: 10, visibility: this.hasChild(item.id) ? "visible" : "hidden"}} src={icon_expand}/>
                                                        {item.label}
                                                    </div>
                                                </td>
                                                <td nowrap="nowrap" style={{textAlign: "left", paddingLeft: 15}}><span className="fontPoppinsRegular13">{numberWithSpaces(item.amount_prev_year)} {this.state.currencyLabel}</span></td>
                                                <td nowrap="nowrap" style={{textAlign: "left", paddingLeft: 15}}><span className="fontPoppinsRegular13">{numberWithSpaces(item.amt)} {this.state.currencyLabel}</span></td>
                                                <td nowrap="nowrap" style={{textAlign: "left", paddingLeft: 15}}><span className="fontPoppinsRegular13">{numberWithSpaces(item.amt - item.amount_prev_year)} {this.state.currencyLabel}</span></td>
                                            </tr>
                                            <div style={{height: 2}}></div>

                                            {item.is_open && this.state.categoryTypes.map(function (secondItem) {
                                                if(secondItem.parent_id == item.id){
                                                    return (
                                                        <React.Fragment>
                                                        <tr style={{backgroundColor: "var(--light-blue)"}} className="clickable" onClick={() => this.onIsOpenChanged(!secondItem.is_open,secondItem.id)}>
                                                            <td style={{padding: 10, fontSize: 13, paddingLeft: 15}} nowrap="nowrap">
                                                                <div className="fontPoppinsRegular13">
                                                                    <img className={secondItem.is_open ? "expandButtonExpanded" : "expandButton"}  style={{width: "10px", height: "10px", marginLeft: 5, marginRight: 10, visibility: this.hasChild(secondItem.id) ? "visible" : "hidden"}} src={icon_expand}/>
                                                                    {secondItem.label}
                                                                </div>
                                                            </td>
                                                            <td nowrap="nowrap" style={{textAlign: "left", paddingLeft: 15}}><span className="fontPoppinsRegular13">{numberWithSpaces(secondItem.amount_prev_year)} {this.state.currencyLabel}</span></td>
                                                            <td nowrap="nowrap" style={{textAlign: "left", paddingLeft: 15}}><span className="fontPoppinsRegular13">{numberWithSpaces(secondItem.amt)} {this.state.currencyLabel}</span></td>
                                                            <td nowrap="nowrap" style={{textAlign: "left", paddingLeft: 15}}><span className="fontPoppinsRegular13">{numberWithSpaces(secondItem.amt - secondItem.amount_prev_year)} {this.state.currencyLabel}</span></td>
                                                        </tr>
                                                        <div style={{height: 2}}></div>

                                                        {secondItem.is_open && this.state.categoryTypes.map(function (thirdItem) {
                                                            if(thirdItem.parent_id == secondItem.id) return (
                                                                <React.Fragment>
                                                                <tr style={{backgroundColor: "var(--lightest-blue)"}}>
                                                                    <td style={{padding: 10, fontSize: 13, paddingLeft: 40}}><span className="fontPoppinsRegular13">{thirdItem.label}</span></td>
                                                                    <td nowrap="nowrap" style={{textAlign: "left", paddingLeft: 15}}><span className="fontPoppinsRegular13">{numberWithSpaces(thirdItem.amount_prev_year)} {this.state.currencyLabel}</span></td>
                                                                    <td nowrap="nowrap" style={{textAlign: "left", paddingLeft: 15}}><span className="fontPoppinsRegular13">{numberWithSpaces(thirdItem.amt)} {this.state.currencyLabel}</span></td>
                                                                    <td nowrap="nowrap" style={{textAlign: "left", paddingLeft: 15}}><span className="fontPoppinsRegular13">{numberWithSpaces(thirdItem.amt - thirdItem.amount_prev_year)} {this.state.currencyLabel}</span></td>
                                                                </tr>
                                                                <div style={{height: 2}}></div>
                                                                </React.Fragment>
                                                            )
                                                        }.bind(this))}

                                                        </React.Fragment>
                                                    )


                                                }
                                            }.bind(this))}

                                            </tbody>
                                        )
                                    }.bind(this))}
                                </table>

                        </div>

                    </div>

                </div>
        );
    }
}

export default FinReports;